import { Box } from "@material-ui/core";
import React from "react";
import NotFound from "../../../../assets/summary/NotFound.svg";
import IconTitle from "../../../shared/components/IconTitle";
import Text from "../../../shared/components/Text";
import { RedirectToMerchantButton } from "../../../shared/components/RedirectToMerchantButton";

export default function Disabled() {
  return (
    <>
      <Box mt={10}>
        <IconTitle
          icon={<img alt="Disabled loan icon" src={NotFound} height="90px" />}
          title={<Text tId="OOPS" />}
          subtitle={<Text tId="LOAN_IS_DISABLED" />}
        />
      </Box>
      <RedirectToMerchantButton />
    </>
  );
}
